import { useEffect } from 'react';
import { DispatchEdit } from '../../document-edit-core';

export const useUndoShortcut = ({
  enabled,
  dispatchEdit,
}: {
  enabled: boolean;
  dispatchEdit: DispatchEdit;
}) => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (enabled && (e.metaKey || e.ctrlKey) && e.key === 'z') {
        dispatchEdit({ type: 'UNDO' });
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [dispatchEdit, enabled]);
};
